import { render, staticRenderFns } from "./Talimat.vue?vue&type=template&id=6d50434a&scoped=true&"
import script from "./Talimat.vue?vue&type=script&lang=js&"
export * from "./Talimat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50434a",
  null
  
)

export default component.exports